import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

/* Spinner de chargement initial */
function Loader() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg-primary)',
    }}>
      <div style={{
        width: 36, height: 36,
        border: '3px solid var(--border)',
        borderTopColor: '#003DA5',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
      }} />
    </div>
  )
}

/**
 * GuestRoute — redirige les utilisateurs déjà connectés vers "/"
 * Usage: <Route path="/auth/login" element={<GuestRoute><Login /></GuestRoute>} />
 */
export default function GuestRoute({ children }) {
  const { isAuth, isLoading } = useAuth()
  if (isLoading)       return <Loader />
  if (isAuth)          return <Navigate to="/" replace />
  return children
}
